import { setGetGamesAction } from '../action';
import { getGames } from '../api/getGames';

export const setGetGames = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getGames(params);
            
            dispatch(setGetGamesAction(data))
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}